/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 252:
/***/ (function(module) {

!function (t, e) {
   true ? module.exports = e() : 0;
}(this, function () {
  "use strict";

  var t = 1e3,
    e = 6e4,
    n = 36e5,
    r = "millisecond",
    i = "second",
    s = "minute",
    u = "hour",
    a = "day",
    o = "week",
    c = "month",
    f = "quarter",
    h = "year",
    d = "date",
    l = "Invalid Date",
    $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,
    y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
    M = {
      name: "en",
      weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
      months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
      ordinal: function (t) {
        var e = ["th", "st", "nd", "rd"],
          n = t % 100;
        return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
      }
    },
    m = function (t, e, n) {
      var r = String(t);
      return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    },
    v = {
      s: m,
      z: function (t) {
        var e = -t.utcOffset(),
          n = Math.abs(e),
          r = Math.floor(n / 60),
          i = n % 60;
        return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
      },
      m: function t(e, n) {
        if (e.date() < n.date()) return -t(n, e);
        var r = 12 * (n.year() - e.year()) + (n.month() - e.month()),
          i = e.clone().add(r, c),
          s = n - i < 0,
          u = e.clone().add(r + (s ? -1 : 1), c);
        return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
      },
      a: function (t) {
        return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
      },
      p: function (t) {
        return {
          M: c,
          y: h,
          w: o,
          d: a,
          D: d,
          h: u,
          m: s,
          s: i,
          ms: r,
          Q: f
        }[t] || String(t || "").toLowerCase().replace(/s$/, "");
      },
      u: function (t) {
        return void 0 === t;
      }
    },
    g = "en",
    D = {};
  D[g] = M;
  var p = "$isDayjsObject",
    S = function (t) {
      return t instanceof _ || !(!t || !t[p]);
    },
    w = function t(e, n, r) {
      var i;
      if (!e) return g;
      if ("string" == typeof e) {
        var s = e.toLowerCase();
        D[s] && (i = s), n && (D[s] = n, i = s);
        var u = e.split("-");
        if (!i && u.length > 1) return t(u[0]);
      } else {
        var a = e.name;
        D[a] = e, i = a;
      }
      return !r && i && (g = i), i || !r && g;
    },
    O = function (t, e) {
      if (S(t)) return t.clone();
      var n = "object" == typeof e ? e : {};
      return n.date = t, n.args = arguments, new _(n);
    },
    b = v;
  b.l = w, b.i = S, b.w = function (t, e) {
    return O(t, {
      locale: e.$L,
      utc: e.$u,
      x: e.$x,
      $offset: e.$offset
    });
  };
  var _ = function () {
      function M(t) {
        this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
      }
      var m = M.prototype;
      return m.parse = function (t) {
        this.$d = function (t) {
          var e = t.date,
            n = t.utc;
          if (null === e) return new Date(NaN);
          if (b.u(e)) return new Date();
          if (e instanceof Date) return new Date(e);
          if ("string" == typeof e && !/Z$/i.test(e)) {
            var r = e.match($);
            if (r) {
              var i = r[2] - 1 || 0,
                s = (r[7] || "0").substring(0, 3);
              return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
            }
          }
          return new Date(e);
        }(t), this.init();
      }, m.init = function () {
        var t = this.$d;
        this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
      }, m.$utils = function () {
        return b;
      }, m.isValid = function () {
        return !(this.$d.toString() === l);
      }, m.isSame = function (t, e) {
        var n = O(t);
        return this.startOf(e) <= n && n <= this.endOf(e);
      }, m.isAfter = function (t, e) {
        return O(t) < this.startOf(e);
      }, m.isBefore = function (t, e) {
        return this.endOf(e) < O(t);
      }, m.$g = function (t, e, n) {
        return b.u(t) ? this[e] : this.set(n, t);
      }, m.unix = function () {
        return Math.floor(this.valueOf() / 1e3);
      }, m.valueOf = function () {
        return this.$d.getTime();
      }, m.startOf = function (t, e) {
        var n = this,
          r = !!b.u(e) || e,
          f = b.p(t),
          l = function (t, e) {
            var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
            return r ? i : i.endOf(a);
          },
          $ = function (t, e) {
            return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(e)), n);
          },
          y = this.$W,
          M = this.$M,
          m = this.$D,
          v = "set" + (this.$u ? "UTC" : "");
        switch (f) {
          case h:
            return r ? l(1, 0) : l(31, 11);
          case c:
            return r ? l(1, M) : l(0, M + 1);
          case o:
            var g = this.$locale().weekStart || 0,
              D = (y < g ? y + 7 : y) - g;
            return l(r ? m - D : m + (6 - D), M);
          case a:
          case d:
            return $(v + "Hours", 0);
          case u:
            return $(v + "Minutes", 1);
          case s:
            return $(v + "Seconds", 2);
          case i:
            return $(v + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, m.endOf = function (t) {
        return this.startOf(t, !1);
      }, m.$set = function (t, e) {
        var n,
          o = b.p(t),
          f = "set" + (this.$u ? "UTC" : ""),
          l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o],
          $ = o === a ? this.$D + (e - this.$W) : e;
        if (o === c || o === h) {
          var y = this.clone().set(d, 1);
          y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
        } else l && this.$d[l]($);
        return this.init(), this;
      }, m.set = function (t, e) {
        return this.clone().$set(t, e);
      }, m.get = function (t) {
        return this[b.p(t)]();
      }, m.add = function (r, f) {
        var d,
          l = this;
        r = Number(r);
        var $ = b.p(f),
          y = function (t) {
            var e = O(l);
            return b.w(e.date(e.date() + Math.round(t * r)), l);
          };
        if ($ === c) return this.set(c, this.$M + r);
        if ($ === h) return this.set(h, this.$y + r);
        if ($ === a) return y(1);
        if ($ === o) return y(7);
        var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1,
          m = this.$d.getTime() + r * M;
        return b.w(m, this);
      }, m.subtract = function (t, e) {
        return this.add(-1 * t, e);
      }, m.format = function (t) {
        var e = this,
          n = this.$locale();
        if (!this.isValid()) return n.invalidDate || l;
        var r = t || "YYYY-MM-DDTHH:mm:ssZ",
          i = b.z(this),
          s = this.$H,
          u = this.$m,
          a = this.$M,
          o = n.weekdays,
          c = n.months,
          f = n.meridiem,
          h = function (t, n, i, s) {
            return t && (t[n] || t(e, r)) || i[n].slice(0, s);
          },
          d = function (t) {
            return b.s(s % 12 || 12, t, "0");
          },
          $ = f || function (t, e, n) {
            var r = t < 12 ? "AM" : "PM";
            return n ? r.toLowerCase() : r;
          };
        return r.replace(y, function (t, r) {
          return r || function (t) {
            switch (t) {
              case "YY":
                return String(e.$y).slice(-2);
              case "YYYY":
                return b.s(e.$y, 4, "0");
              case "M":
                return a + 1;
              case "MM":
                return b.s(a + 1, 2, "0");
              case "MMM":
                return h(n.monthsShort, a, c, 3);
              case "MMMM":
                return h(c, a);
              case "D":
                return e.$D;
              case "DD":
                return b.s(e.$D, 2, "0");
              case "d":
                return String(e.$W);
              case "dd":
                return h(n.weekdaysMin, e.$W, o, 2);
              case "ddd":
                return h(n.weekdaysShort, e.$W, o, 3);
              case "dddd":
                return o[e.$W];
              case "H":
                return String(s);
              case "HH":
                return b.s(s, 2, "0");
              case "h":
                return d(1);
              case "hh":
                return d(2);
              case "a":
                return $(s, u, !0);
              case "A":
                return $(s, u, !1);
              case "m":
                return String(u);
              case "mm":
                return b.s(u, 2, "0");
              case "s":
                return String(e.$s);
              case "ss":
                return b.s(e.$s, 2, "0");
              case "SSS":
                return b.s(e.$ms, 3, "0");
              case "Z":
                return i;
            }
            return null;
          }(t) || i.replace(":", "");
        });
      }, m.utcOffset = function () {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, m.diff = function (r, d, l) {
        var $,
          y = this,
          M = b.p(d),
          m = O(r),
          v = (m.utcOffset() - this.utcOffset()) * e,
          g = this - m,
          D = function () {
            return b.m(y, m);
          };
        switch (M) {
          case h:
            $ = D() / 12;
            break;
          case c:
            $ = D();
            break;
          case f:
            $ = D() / 3;
            break;
          case o:
            $ = (g - v) / 6048e5;
            break;
          case a:
            $ = (g - v) / 864e5;
            break;
          case u:
            $ = g / n;
            break;
          case s:
            $ = g / e;
            break;
          case i:
            $ = g / t;
            break;
          default:
            $ = g;
        }
        return l ? $ : b.a($);
      }, m.daysInMonth = function () {
        return this.endOf(c).$D;
      }, m.$locale = function () {
        return D[this.$L];
      }, m.locale = function (t, e) {
        if (!t) return this.$L;
        var n = this.clone(),
          r = w(t, e, !0);
        return r && (n.$L = r), n;
      }, m.clone = function () {
        return b.w(this.$d, this);
      }, m.toDate = function () {
        return new Date(this.valueOf());
      }, m.toJSON = function () {
        return this.isValid() ? this.toISOString() : null;
      }, m.toISOString = function () {
        return this.$d.toISOString();
      }, m.toString = function () {
        return this.$d.toUTCString();
      }, M;
    }(),
    k = _.prototype;
  return O.prototype = k, [["$ms", r], ["$s", i], ["$m", s], ["$H", u], ["$W", a], ["$M", c], ["$y", h], ["$D", d]].forEach(function (t) {
    k[t[1]] = function (e) {
      return this.$g(e, t[0], t[1]);
    };
  }), O.extend = function (t, e) {
    return t.$i || (t(e, _, O), t.$i = !0), O;
  }, O.locale = w, O.isDayjs = S, O.unix = function (t) {
    return O(1e3 * t);
  }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";

// NAMESPACE OBJECT: ./lib/SubscriptionBox.js
var SubscriptionBox_namespaceObject = {};
__webpack_require__.r(SubscriptionBox_namespaceObject);
__webpack_require__.d(SubscriptionBox_namespaceObject, {
  activateItem: function() { return activateItem; },
  addItem: function() { return addItem; },
  changeAddress: function() { return changeAddress; },
  changeFrequency: function() { return changeFrequency; },
  changeItemChargeDate: function() { return changeItemChargeDate; },
  changeItemQuantity: function() { return changeItemQuantity; },
  getCurrentMembershipStatus: function() { return getCurrentMembershipStatus; },
  getProductRecommendations: function() { return getProductRecommendations; },
  getSubscriptionBox: function() { return getSubscriptionBox; },
  loadBoxSuggestions: function() { return loadBoxSuggestions; },
  removeItem: function() { return removeItem; },
  sendPaymentMethodEmail: function() { return sendPaymentMethodEmail; },
  setChargeDay: function() { return setChargeDay; },
  skipBox: function() { return skipBox; },
  skipItem: function() { return skipItem; },
  upgradeMembership: function() { return upgradeMembership; }
});

// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(252);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./lib/SubscriptionBox.js


// FIXME: make a shopifyQuery helper that is used both here and as the shopifyQuery vue mixin, rather than duplicate
async function _shopifyGraphQLRequest(query, variables) {
  const storefrontAccessToken = "e6979a3c407c1bc2a0886a21840cee60";
  const response = await fetch("https://hive-brands.myshopify.com/api/2022-07/graphql.json", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": storefrontAccessToken
    },
    body: JSON.stringify({
      query,
      variables
    })
  });
  return response.json();
}
const _fetchVariantData = async function (variant_ids) {
  let query = `
    query ($variant_ids: [ID!]!) {
      nodes(ids:$variant_ids) {
        ...on ProductVariant {
          id
          availableForSale
          quantityAvailable
          image{
            url
          }
          price {
            amount 
          }
          product {
            handle
            vendor
            tags
            featuredImage {
              url
            }
          }
        }
      }
    }
  `;

  // FIXME: error handling
  let response = false;
  try {
    response = await _shopifyGraphQLRequest(query, {
      variant_ids
    });
  } catch (e) {
    console.error("Error with Shopify query:", e);
  }
  let variant_data = response?.data?.nodes;
  return variant_data;
};
const _addExtendedDataToSubscriptions = async function (subscriptions) {
  let variant_ids = subscriptions.map(subscription => {
    let variant_id = subscription?.external_variant_id?.ecommerce;
    if (!variant_id) {
      return false;
    }
    return `gid://shopify/ProductVariant/${variant_id}`;
  }).filter(v => {
    return v !== false;
  });
  let variant_data = [];
  try {
    variant_data = await _fetchVariantData(variant_ids);
  } catch (e) {
    console.error("Error fetching variant data", e);
  }

  // FIXME: clean this up
  return subscriptions.map(c => {
    let shopify_variant_id = c.external_variant_id.ecommerce;
    let extended_data = variant_data.find(v => v?.id.includes(shopify_variant_id));
    c.extended_data = {};

    // change made 8.14, if no extended_data found, then the product must be archived or disabled in Shopify
    // in which case, do not show, per request from Kate
    if (!extended_data) {
      return false;
    }

    //Code to remove discontinued products from box
    // let is_discontinued = extended_data.product.tags.includes('Discontinued')
    // if (is_discontinued) {
    //   return false;
    // }

    const variant_image_url = extended_data.image.url ? extended_data.image.url : extended_data.product.featuredImage.url;
    c.extended_data = {
      product_handle: extended_data.product.handle,
      product_vendor: extended_data.product.vendor,
      original_price: extended_data.price.amount,
      product_image_url: variant_image_url,
      variant_available: extended_data.availableForSale,
      available_inventory: extended_data.quantityAvailable,
      out_of_stock: c.quantity > extended_data.quantityAvailable
    };
    return c;
  }).filter(c => {
    if (hasExtendedData(c)) {
      return c;
    }
  });
};
const _getApiBaseUrl = function (customer_id) {
  return `https://hive-support.herokuapp.com/api/customers/${customer_id}`;
  //return `http://localhost:7700/api/customers/${customer_id}` 
};

const _getBoxDataBaseUrl = function (customer_id) {
  return _getApiBaseUrl(customer_id) + '/subscription-box-v2/';
};
const getProductRecommendations = async function (customer_id) {
  let response = await fetch(_getBoxDataBaseUrl(customer_id) + "suggestions");
  return await response.json();
};
const getSubscriptionBox = async function (customer_id) {
  let reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!customer_id) {
    throw 'No customer id given. Cannot load box details';
  }
  let box = null;
  let cached_box = null;

  //Local Storage Check for Customer Recharge Data
  try {
    const cached_data = JSON.parse(localStorage.getItem("recharge_customer_data"));
    const isExpired = time_limit_string => {
      if (!time_limit_string) {
        return true;
      }

      // Get the current time with DayJS
      const currentTime = dayjs_min_default()();
      const parsed_time_limit = dayjs_min_default()(time_limit_string);

      // Check if the current time is after the target time (including the target time itself)
      return currentTime.isAfter(parsed_time_limit, 'minute');
    };
    if (!isExpired(cached_data?.expires_at)) {
      cached_box = cached_data.box;
    }
    if (cached_box && reload !== true) {
      return cached_box;
    }
  } catch (error) {
    console.error("Error loading cached subscription box data", error);
  }
  console.log("Refreshing Customer Data");
  localStorage.removeItem("recharge_customer_data"); //removing old Customer Data if present

  box = await fetch(_getBoxDataBaseUrl(customer_id)).then(response => response.json());
  box.customer_id = customer_id;

  // FIXME: rethink this "addextendeddata" thing
  box.contents = await _addExtendedDataToSubscriptions(box.contents);
  box.other_subscriptions = await _addExtendedDataToSubscriptions(box.other_subscriptions);
  box.cancelled_subscriptions = await _addExtendedDataToSubscriptions(box.cancelled_subscriptions);
  try {
    localStorage.setItem("recharge_customer_data", JSON.stringify({
      box: box,
      expires_at: dayjs_min_default()().add(30, 'minute').format()
    }));
  } catch (e) {
    console.error("Error storing subscription box cache", e);
  }
  console.log("Subscription box loaded:", box);
  return box;
};
const getCurrentMembershipStatus = async function (customer_id) {
  let box = await getSubscriptionBox(customer_id);
  return box.membership_type;
};
const sendPaymentMethodEmail = async box => {
  let response = await fetch(_getBoxDataBaseUrl(box.customer_id) + 'send-notification', {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      type: "email",
      template_type: "shopify_update_payment_information"
    })
  });
  return response.json();
};
const skipBox = async box => {
  return _updateBox(box, 'skip');
};
const setChargeDay = async (box, charge_day) => {
  return _updateBox(box, 'set-charge-day', {
    charge_day
  });
};
const changeItemQuantity = async (box, subscription_id, quantity) => {
  return _updateBox(box, 'change-item-quantity', {
    subscription_id,
    quantity
  });
};
const changeItemChargeDate = async (box, subscription_id, charge_date) => {
  return _updateBox(box, 'change-item-charge-date', {
    subscription_id,
    charge_date
  });
};
const changeFrequency = async (box, frequency) => {
  return _updateBox(box, 'change-frequency', {
    frequency
  });
};
const changeAddress = async (box, address) => {
  return _updateBox(box, 'change-address', {
    address
  });
};
const skipItem = async (box, subscription_id) => {
  return _updateBox(box, 'skip-item', {
    subscription_id
  });
};
const addItem = async function (box, variant_id, quantity) {
  let recurring = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return _updateBox(box, 'add-item', {
    variant_id,
    quantity,
    recurring
  });
};
const activateItem = async (box, subscription_id) => {
  return _updateBox(box, 'activate-item', {
    subscription_id
  });
};
const removeItem = async function (box, item_id) {
  let item_type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "subscription";
  return _updateBox(box, 'remove-item', {
    item_id,
    item_type
  });
};
const upgradeMembership = async box => {
  return _updateBox(box, 'upgrade-membership');
};
const loadBoxSuggestions = async box => {
  let suppressed_suggestions = JSON.parse(localStorage.getItem('suppressed_suggestions'));
  if (!suppressed_suggestions) {
    suppressed_suggestions = [];
  }
  let product_ids_in_box = box.contents.map(c => parseInt(c.external_product_id.ecommerce));
  suppressed_suggestions = suppressed_suggestions.concat(product_ids_in_box);
  console.log("Loading suggestions but filtering out suppressions", suppressed_suggestions);
  // TODO: pull from different endpoint or something smarter
  return fetch(`/collections/best-sellers/products.json`).then(response => response.json()).then(response => response.products).then(products => products.filter(p => !p.tags.includes('Discontinued'))).then(suggestions => suggestions.filter(s => !suppressed_suggestions.includes(s.id)))
  //Only Show 1st 12 Product Suggestions
  .then(final_list => {
    if (final_list.length < 12) return final_list;
    return final_list.slice(0, 12);
  });
};
function hasExtendedData(obj) {
  //Goal: Check if extended data is a valid object with key and value pairs inside of it
  return obj !== undefined && obj !== null && typeof obj === "object" && Object.keys(obj).length > 0;
}
async function _updateBox(box, endpoint, updates) {
  let response = await fetch(_getBoxDataBaseUrl(box.customer_id) + endpoint, {
    method: 'PUT',
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(updates)
  });
  return await response.json();
}
;// CONCATENATED MODULE: ./lib.js

window.Hive = {
  SubscriptionBox: SubscriptionBox_namespaceObject
};
}();
/******/ })()
;